import { AxiosResponse } from "axios"
import { IBroadcastRequest } from "./types"
import { apiInstance } from "../base"

export const broadcast = (data: IBroadcastRequest): Promise<AxiosResponse<void>> => {
    return apiInstance.handler.post(`/notifications/broadcast`, data)
}
